module.exports = __webpack_public_path__ + "media/fonts/SFProText-Light-519dfab5bbddec8a4e7a8a5ceb1697b3.eot";